module.exports = __webpack_public_path__ + "static/1-cd835926e0b96d7d58807a8981c23fa4.png";